import { apiGet } from '@/store/api';

export async function getWorklineStatements(callId: number, groupId: number, statusId: number) {
  const data = await apiGet(`sof/workStatements/${callId}/${groupId}/${statusId}`);
  return data;
}
